var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/EyeInWindow.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const EyeInWindow = ({
  color = '#4C5ECF',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    d: "M15.8333 2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.7583 2.5 15.8333 2.5ZM15.8333 15.8333H4.16667V5.83333H15.8333V15.8333ZM11.25 10.8333C11.25 11.525 10.6917 12.0833 10 12.0833C9.30833 12.0833 8.75 11.525 8.75 10.8333C8.75 10.1417 9.30833 9.58333 10 9.58333C10.6917 9.58333 11.25 10.1417 11.25 10.8333ZM10 7.5C7.725 7.5 5.78333 8.88333 5 10.8333C5.78333 12.7833 7.725 14.1667 10 14.1667C12.275 14.1667 14.2167 12.7833 15 10.8333C14.2167 8.88333 12.275 7.5 10 7.5ZM10 12.9167C8.85 12.9167 7.91667 11.9833 7.91667 10.8333C7.91667 9.68333 8.85 8.75 10 8.75C11.15 8.75 12.0833 9.68333 12.0833 10.8333C12.0833 11.9833 11.15 12.9167 10 12.9167Z",
    fill: color
  })
});